module.exports = __webpack_public_path__ + "assets/img/27b68f1a21a61b9111dbee0798292d2b.png";